import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Input, Grid, Button, TextArea, Form, Dropdown } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    name: '',
    states: '',
    mobile: '',
    altmobile: '',
    email: '',
    address: '',
    taluk: '',
    district: '',
    pincode: '',
    gst: ''
  };

  handleClickOpen = () => {

    if (this.props.type == 'add') {
      this.setState({ open: true });
    }
    else {
      let name, states, mobile, altmobile, email, address, taluk, district, pincode, gst;
      this.props.data.map((x) => {
        if (this.props.id == x.id) {
          name = x.name;
          states = x.state;
          mobile = x.mobile;
          altmobile = x.alt_mobile;
          email = x.email;
          address = x.address;
          taluk = x.taluk;
          district = x.district;
          pincode = x.pincode;
          gst = x.GSTIN;
        }
      })
      this.setState({ name: name, states: states, mobile: mobile, altmobile: altmobile, email: email, address: address,
                      taluk: taluk, district: district, pincode: pincode, gst: gst, open: true })
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleMaxWidthChange = event => {
    this.setState({ maxWidth: event.target.value });
  };

  handleFullWidthChange = event => {
    this.setState({ fullWidth: event.target.checked });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit = () => {
    let context = this;
    let name = this.state.name;
    let states = this.state.states;
    let mobile = this.state.mobile;
    let altmobile = this.state.altmobile;
    let email = this.state.email;
    let address = this.state.address;
    let taluk = this.state.taluk;
    let district = this.state.district;
    let pincode = this.state.pincode;
    let gst = this.state.gst;


    if (name == undefined || name == '' || name == null) {
      alert('Enter Name!!!');
      return;
    }
    if (states == undefined || states == '' || states == null) {
      alert('Enter states!!!');
      return;
    }
    if (mobile == undefined || mobile == '' || mobile == null) {
      alert('Enter mobile!!!');
      return;
    }
    if (taluk == undefined || taluk == '' || taluk == null) {
      alert('Enter taluk!!!');
      return;
    }
    if (district == undefined || district == '' || district == null) {
      alert('Enter District!!!');
      return;
    }

    let data1 = { 'name': name, 'states': states, 'mobile': mobile, 'altmobile': altmobile, 
    'email': email, 'address': address, 'taluk': taluk, 'district': district, 'pincode': pincode, 
    'gst': gst, 'type': 'machine' };
    let url = Server() + 'machinecustomer/insert.php';
    if (this.props.type == 'edit') {
      data1 = { 'name': name, 'states': states, 'mobile': mobile, 'altmobile': altmobile, 'email': email, 'address': address, 'taluk': taluk, 'district': district, 'pincode': pincode, 'gst': gst, 'id': this.props.id };
      url = Server() + 'machinecustomer/update.php';
    }
    this.setState({ load: true, message: 'Adding Details' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: url,
      success: function(data)
      {
        context.setState({ load: false, open: false })
        context.props.getMachineCustomer(1);
        console.log(data);
        if (data == 1) {
          context.setState({ name: '', states: '', mobile: '', altmobile: '', email: '', address: '',
                            taluk: '', district: '', pincode: '', gst: '', open: false })
          context.props.getMachineCustomer(1);
        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });

  }

  statesChnage = (f, { value }) => {
    this.setState({ states: value });
  }

  render() {
    const { classes } = this.props;
    let menu = [
      { key: 'Tamil Nadu', text: 'Tamil Nadu', value: 'Tamil Nadu' },
      { key: 'Karnataka', text: 'Karnataka', value: 'Karnataka' },
      { key: 'Kerala', text: 'Kerala', value: 'Kerala' },
      { key: 'Andhra Pradesh', text: 'Andhra Pradesh', value: 'Andhra Pradesh' },
    ];
    return (
      <React.Fragment>
        <Loading load={this.state.load} message={this.state.message} />
        { (this.props.type == 'add') ?
          (
            <Button primary onClick={this.handleClickOpen} style={{display: this.props.machinecustomeredit}}>
              Add Customer
            </Button>
          ) :
          (
            <div onClick={this.handleClickOpen}>Edit</div>
          )
        }

        <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">{this.props.title}</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Name<br/>
                <Input value={this.state.name} onChange={this.handleChange('name')} fluid />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                State<br/>
                <Dropdown placeholder='State' style={{ borderColor: '#5A9CBB' }}
                 fluid search selection onChange={this.statesChnage} fluid
                 options={menu} value={this.state.states} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                Mobile<br/>
                <Input value={this.state.mobile} style={{fontSize: 12}} onChange={this.handleChange('mobile')} fluid  />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                Alternative mobile<br/>
                <Input value={this.state.altmobile} style={{fontSize: 12}} onChange={this.handleChange('altmobile')} fluid  />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                Email<br/>
                <Input value={this.state.email} style={{fontSize: 12}} onChange={this.handleChange('email')} fluid  />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                Address<br/>
                <Form>
                  <TextArea fluid value={this.state.address} onChange={this.handleChange('address')} />
                </Form>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                Taluk<br/>
                <Input value={this.state.taluk} style={{fontSize: 12}} onChange={this.handleChange('taluk')} fluid  />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                District<br/>
                <Input value={this.state.district} style={{fontSize: 12}} onChange={this.handleChange('district')} fluid  />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                Pincode<br/>
                <Input value={this.state.pincode} style={{fontSize: 12}} onChange={this.handleChange('pincode')} fluid  />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                GST<br/>
                <Input value={this.state.gst} style={{fontSize: 12}} onChange={this.handleChange('gst')} fluid  />
              </Grid.Column>


              <Grid.Column mobile={16} tablet={16} computer={8}>
                <br/>
                <Button primary onClick={this.submit}>Submit</Button>
              </Grid.Column>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);
